import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Glyph from '../components/Glyph/Glyph.js';

var GlyphInfo = function GlyphInfo(_ref) {
  var title = _ref.title,
      otherProps = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React.createElement(Glyph, otherProps, /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 5a1 1 0 011 1v5a1 1 0 01-2 0V7a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z"
  })));
};

export default GlyphInfo;
